export default "__VITE_ASSET__166d284e__"